import { Container as MuiContainer } from "@mui/material";
import React from "react";

export default function Container({ children, ...rest }) {
  return <MuiContainer {...rest}>{children}</MuiContainer>;
}
